var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "92px",
    viewBox: "0 0 92 92",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70EFBF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB8EB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#0E1C39",
    x: 0,
    y: 0,
    width: 92,
    height: 92,
    rx: 21.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5415935,48.5107945 C66.8849649,48.1688086 67.4402118,48.1688086 67.7835832,48.5107945 L73.098811,53.8045764 C73.4442927,54.1514475 73.4431663,54.7086315 73.098811,55.0515975 L46.6209948,81.4225808 C46.2776235,81.7645667 45.7223765,81.7645667 45.3790052,81.4225808 L18.901189,55.0515975 C18.5557073,54.7047264 18.5568337,54.1475423 18.901189,53.8045764 L24.2164168,48.5107945 C24.5597882,48.1688086 25.1150351,48.1688086 25.4584065,48.5107945 L28.6144067,51.6540609 C28.9598711,52.0008715 28.9587796,52.5580556 28.6144457,52.9010431 L27.7072609,53.8046809 C27.3618182,54.1515131 27.3629445,54.7086971 27.7072999,55.0516631 L45.3791077,72.6521685 C45.722479,72.9941544 46.277726,72.9941544 46.6210973,72.6521685 L64.2928754,55.0516927 C64.6383529,54.7048362 64.637235,54.1476522 64.2928848,53.804681 L63.3856136,52.901043 C63.0401413,52.5541813 63.0412676,51.9969973 63.385623,51.6540313 Z M46.6495329,27.6319139 L64.6459661,45.555735 C64.9914478,45.9026061 64.9903214,46.4597901 64.6459661,46.8027561 L46.6495329,64.7265771 C46.3061616,65.068563 45.7509146,65.068563 45.4075433,64.7265771 L27.4111101,46.8027561 C27.0656284,46.455885 27.0667547,45.8987009 27.4111101,45.555735 L45.4075433,27.6319139 C45.7509146,27.289928 46.3061616,27.289928 46.6495329,27.6319139 Z M45.4075433,36.4023262 L36.2170526,45.555735 C35.8715709,45.9026061 35.8726972,46.4597901 36.2170526,46.8027561 L45.4075433,55.9561649 C45.7509146,56.2981508 46.3061616,56.2981508 46.6495329,55.9561649 L55.8400236,46.8027561 C56.1855053,46.455885 56.1843789,45.8987009 55.8400236,45.555735 L46.6495329,36.4023262 C46.3061616,36.0603403 45.7509146,36.0603403 45.4075433,36.4023262 Z M46.6209948,10.6807436 L73.098811,37.0517268 C73.4431663,37.3946928 73.4442927,37.9518768 73.1013267,38.2962322 L67.7835832,43.5925298 C67.4402118,43.9345157 66.8849649,43.9345157 66.5415935,43.5925298 L63.385623,40.4492931 C63.0412676,40.1063271 63.0401413,39.549143 63.3831073,39.2047877 L64.2928848,38.2986434 C64.637235,37.9556722 64.6383529,37.3984881 64.2953817,37.0541379 L46.6210973,19.4511558 C46.277726,19.1091699 45.722479,19.1091699 45.3791077,19.4511558 L27.7072999,37.0516612 C27.3629445,37.3946272 27.3618182,37.9518112 27.7047842,38.2961666 L28.6144457,39.2022812 C28.9587796,39.5452687 28.9598711,40.1024529 28.6168836,40.4467868 L25.4584065,43.5925298 C25.1150351,43.9345157 24.5597882,43.9345157 24.2164168,43.5925298 L18.901189,38.298748 C18.5568337,37.955782 18.5557073,37.398598 18.8986733,37.0542426 L45.3790052,10.6807436 C45.7223765,10.3387577 46.2776235,10.3387577 46.6209948,10.6807436 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8b66e175aa8c61febabf542a87080333.svg";
export { ForwardRef as ReactComponent };